import { widgetMock } from "../NavigationWidgets/NavigationWidgets.props.mock";
export const secondaryNavigationMock = {
    data: [
        { title: "Support", href: "#", sections: [] },
        { title: "Deposit", href: "#", sections: [] },
    ],
    widgets: widgetMock,
};
